import { useTranslation } from 'react-i18next'
import { useScanContainerLocation } from './ScanContainerLocation.hooks'
import {
  AtlasBodyTitle,
  AtlasH1,
  AtlasH2,
  AtlasH3,
  Filler,
  Icon,
  Icons,
  PageContentAtom
} from '@justomx/atlas-components'
import { MenuWrapperOrganism } from 'components/organisms/MenuWrapper.organism'

export const ScanContainerLocationPage = () => {
  useScanContainerLocation()

  return (
    <>
      <MenuWrapperOrganism
        title="Corregir inventario"
        secondaryAction={Icons.IcKeyboardIcon}
        onSecondaryAction={() => {}}
      />
      <PageContentAtom $centered>
        <Filler flexGrow={1} />
        <AtlasH2 style={{ color: '#c2c2c2' }}>Escanea</AtlasH2>
        <AtlasH1 style={{ textAlign: 'center' }}>Ubicación<br /> o<br /> Tarima</AtlasH1>
        <Filler />
      </PageContentAtom>
    </>
  )
}
